import styled from 'styled-components';

export const FilterButton = styled.button.attrs({
  type: 'button',
})`
  border: 0;
  background: 0;
  position: relative;
  padding: 0 0px 5px;
  margin-left: 20px;
  ${({ theme }) => theme.fontTypes.type1}
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.color100};
  cursor: pointer;

  &:first-child {
    margin-left: 0;
  }

  ${(props: any) => {
    if (props['data-active']) {
      return `
          &::after {
            content: '';
            display: block;
            width: 100%;
            height: 2px;
            background: ${props.theme.colors.primary_400};
            position: absolute;
            left: 0;
            bottom: 0;
          }
        `;
    }

    return ``;
  }}
`;
